<template>
    <div v-if="messageContainer.paymentSuccess">
        <div class="text-container">
            <p class="successMessage">
                {{ $t("Vielen Dank für die Bestellung! In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.") }}
            </p>
        </div>
    </div>
    <div v-else-if="messageContainer.serverError">
        <div class="alert-container">
            <p class="alertMessage">
                {{ messageContainer.modalDescription }}
                {{ messageContainer.message }}.<br>
                {{ messageContainer.sorryMessage }}
            </p>
        </div>

    </div>

    <div v-else-if="unavailableTickets">
        <div class="alert-container">
            <p class="alertMessage">
                {{ $t("Entschuldigung. Die Anzahl der gewünschten Tickets ist derzeit nicht verfügbar.")}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    mixins: [],
    props: ['messageContainer'],
    components: {},
    data: () => {
        return {

        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>
